import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useGoogleTagManager = () => {
    const location = useLocation();
    console.log("location", location);
    useEffect(() => {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'pageview',
                page: location.pathname + location.search,
            });
        }
    }, [location]);
};

export default useGoogleTagManager;
